export function logFailedPromise(e) {
  console.error("Unexpected Failure");
  console.error(e);
}
